import { useQueryClient } from 'react-query'

import { getProfile } from 'services/endpoints/profile'
import { useSetUserProfile } from 'store'

export const useRefetchUserProfile = () => {
    const queryClient = useQueryClient()

    const refetchProfile = async () => {
        const response = await getProfile()

        queryClient.setQueryData('user-profile', response)
        useSetUserProfile(response)
    }

    return {
        refetchUserProfile: refetchProfile
    }
}
